
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.618 1.057a1.324 1.324 0 00-1.063.573l-8.19 11.827L2.373 7.63a1.324 1.324 0 00-1.87-.143 1.324 1.324 0 00-.144 1.87L6.47 16.49a1.324 1.324 0 002.097-.111l9.169-13.244a1.324 1.324 0 00-.339-1.842 1.324 1.324 0 00-.78-.235z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    